import React from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  icon?: React.ReactNode;
  className?: string;
}

const changeColors = {
  positive: 'text-emerald-400',
  negative: 'text-red-400',
  neutral: 'text-white/50',
};

export function StatCard({ label, value, change, changeType = 'neutral', icon, className = '' }: StatCardProps) {
  return (
    <div className={`rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-5 ${className}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-white/50">{label}</p>
          <p className="mt-1 text-3xl font-bold text-white">{value}</p>
          {change && (
            <p className={`mt-1 text-xs ${changeColors[changeType]}`}>{change}</p>
          )}
        </div>
        {icon && (
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/5 text-white/40">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
